import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { Name, Status, Date } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getDynamicForm as onGetDynamicForm,
  addDynamicForm as onaddDynamicForm,
  updateDynamicForm as onUpdateDynamicForm,
  deleteDynamicForm as onDeleteDynamicForm,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import moment from "moment";

//redux
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

const ContactsList = props => {

  //meta title
  document.title = "Abonelikler | Oyliyo ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [getEdit, setEdit] = useState();

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (getEdit && getEdit.Pool_Question_Title) || "",
      type: (getEdit && getEdit.PoolQuestionType) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen Soruyu Giriniz"),
      type: Yup.string().required("Soru Tipini Giriniz"),
    }),
    onSubmit: values => {
      var localDate = moment().local();

      				
      if (isEdit) {
        const updateUser = {
          ID: getEdit.ID,
          Pool_Question_Title:values.title,
          Pool_ID: 1,
          PoolQuestionType: values.type,
                };
                console.log("updateUser",updateUser)
        // update user
        dispatch(onUpdateDynamicForm(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Pool_Question_Title:values["title"],
          Pool_ID: 1,
          PoolQuestionType: values["type"],
        };
        // save new user
        dispatch(onaddDynamicForm(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.dynamic,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getEditForm, setEditForm] = useState(false);


  const [modalOption, setModalOption] = useState(false);

  
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
      {
        Header: "Başlık",
        accessor: "InAppOption_Title",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },
    
   
      {
        Header: "Ücret",
        accessor: "InAppOption_Price",
        filterable: true,
        disableFilters: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },
    


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetDynamicForm());
      setIsEdit(false);
   }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleOption = () => {
    setModalOption(!modalOption);
  };

  
  const handleUserOption = arg => {
    const user = arg;
    setOptions(user.Pool_Answer)

    setOptionsData(user)
    console.log("şlmsdşlf",user.Pool_Answer)
    toggleOption();
  };

  const handleUserClick = arg => {
    const user = arg;
    setEditForm(user)
    setContact(user);
    setIsEdit(true);



    setEdit(user)
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteDynamicForm(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };


  const [options, setOptions] = useState([]); // Seçenekleri tutan dizi
  const [inputValue, setInputValue] = useState(""); // Input alanı değeri
  const [getOptionsData, setOptionsData] = useState(null); // Input alanı değeri

  
  // Seçenek ekleme işlevi
  const addOption = () => {
    if (inputValue.trim() !== "") {
      setOptions([...options, {"Pool_Answer_Text" : inputValue, Pool_Question_ID : getOptionsData.ID}]); // Yeni değeri options dizisine ekle
      setInputValue(""); // Input alanını temizle
    }
  };

  // Kaydet işlevi
 // Seçeneği silme işlevi
 const removeOption = async (ID) => {

  try {

    axios.delete(`https://adminoy.oyliyo.com.tr:9654/deletePoolAnswer/${ID}`).then(async (res) => {

      setTimeout(() => dispatch(onGetDynamicForm()), 1000)

      toggleOption()
    })
  } catch (error) {
    //yield put(updateUserFail(error))
  }


  /*  const filteredData = getFileSubMediaAdd.filter(item => item.ID !== itemData.ID )
    setFileSubMediaAdd(filteredData);*/

}
// Seçenekleri kaydetme işlevi
const saveOptions = async () => {
  try {

    const responses = await Promise.all(


      options.map((item, index) => {
        console.log("şlmsdfş",item)
      const newUser = {
        Pool_Question_ID: item.Pool_Question_ID,
        Pool_Answer_Text: item.Pool_Answer_Text,
      }

      axios.post('https://adminoy.oyliyo.com.tr:9654/addPoolAnswer/send', newUser)

      setTimeout(() => dispatch(onGetDynamicForm()), 1000)

      toggleOption();
    })
  )

    console.log("Tüm seçenekler başarıyla kaydedildi:", responses);

  } catch (error) {
    console.error("Seçenekleri kaydederken hata oluştu:", error);
  }
};

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Abonelikler" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddDynamicForm={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

<Modal isOpen={modalOption} toggle={toggleOption}>
      <ModalHeader toggle={toggleOption} tag="h4">
        {"Seçenek Ekle"}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Input
              type="text"
              placeholder="Seçenek girin"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <Button color="primary" onClick={addOption} className="mt-2">
              +
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <ul>
              {options.map((option, index) => (
                <li key={index}>
                  {option.Pool_Answer_Text} 
                  <Button color="danger" size="sm" onClick={() => removeOption(option.ID)} className="ml-2">
                    Sil
                  </Button>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
        <Button color="success" onClick={saveOptions}>
          Kaydet
        </Button>
      </ModalBody>
    </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Anket Düzenle" : "Anket Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Soru</Label>
                              <Input
                                name="title"
                                type="text"
                                placeholder="Soru"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Soru Tipi</Label>
                              <Input
                                name="type"
                                label="type"
                                type="text"
                                placeholder="Soru Tipini Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.type || ""}
                                invalid={
                                  validation.touched.type &&
                                    validation.errors.type
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.type &&
                                validation.errors.type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.type}
                                </FormFeedback>
                              ) : null}
                            </div>
                         
                      
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
